import * as _ from 'lodash';

import { ApproverDTO } from 'app/model/approver-dto';
import { CommonDTO } from './../model/common-dto';
import { CustomMessages } from '@shared';
import { EmailSuppInfoDTO } from 'app/model/email-suppInfo-dto';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PostCommentInput } from 'app/model/post-comment-input-dto';
import { TemplateMaster } from 'app/model/template-master';
import { TemplateMasterItemSearch } from './../model/template-master-search';
import { WorkflowApproveDTO } from 'app/model/workflow-approve-dto';
import { WorkflowRequestSearchDTO } from 'app/model/workflow-request-search-dto';
import { environment } from '../../environments/environment';
import { WorkflowHandoverDTO } from 'app/model/workflow-handover.dto';
import { StandardRepoDocDTO } from 'app/model/standard-repo-doc-dto';
import { AuditScoreBoardDTO } from 'app/model/audit-score-board-dto';
import { UrlConfigService } from './url-config.service';
import { AuditPlanDTO } from 'app/model/audit-plan-dto';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  // url = environment.SERVER_URL;
  url: string;
  token = '';
  TOKEN = 'token';

  constructor(
    private http: HttpClient,
    private customMessage: CustomMessages,
    private urlConfigService: UrlConfigService
  ) {
    this.url = this.urlConfigService.apiServerUrl;
  }

  getIsNcFinalizedFlag(commonDto: CommonDTO) {
    return this.http.post(`${this.url}common/isNcFinalized`, commonDto);
  }
  getAuditFirmList() {
    return this.http.post(`${this.url}common/audit-firm-list`, { clientId: '1' });
  }
  getDepartmentList() {
    return this.http.post(`${this.url}common/client-department-list`, { clientId: '1' });
  }
  getDepartmentList1(standardRepoDocDTO: StandardRepoDocDTO) {
    return this.http.post(`${this.url}siterepodoc/siterepodoc-department-list`, standardRepoDocDTO);
  }
  getSectionBasedOnDepartment(templateMasterItemSearch: TemplateMasterItemSearch) {
    return this.http.post(`${this.url}common/section-list`, templateMasterItemSearch);
  }
  getApproverList(templateMaster: TemplateMaster) {
    return this.http.post(`${this.url}common/user-approver-combo`, templateMaster);
  }

  getFinancialYearList(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/financial-year-list`, commonDTO);
  }

  getQuarterList(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/quarter-list`, commonDTO);
  }

  getCompanyList(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/company-list`, commonDTO);
  }

  getCompanyListByClientNUserIdNRegionId(commonDTO: CommonDTO) {
    return this.http.post(
      `${this.url}common/company-list-by-client-n-userId-n-regionId`,
      commonDTO
    );
  }
  getCompanyListByClientNUserIdNRegionIdGlobal(commonDTO: CommonDTO) {
    return this.http.post(
      `${this.url}common/company-list-by-client-n-userId-n-regionId-global`,
      commonDTO
    );
  }

  getSiteSelectionListByCompanyIdNUserId(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/company-site-list`, commonDTO);
  }

  getSiteSelectionListByRegionIdCompanyIdNUserId(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/company-site-list-by-region`, commonDTO);
  }
  getSiteSelectionListByRegionIdCompanyIdNUserIdGlobal(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/company-site-list-by-region-global`, commonDTO);
  }

  getCurrentFinancialYearAndQuarter(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/quarter-list`, commonDTO);
  }
  getTabsByUserId(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/user-role`, commonDTO);
  }

  getSiteComboList(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/site-list`, commonDTO);
  }

  getDepNSectionSelectionListByAuditId(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/audit-program-department-section-list`, commonDTO);
  }

  getApproverActionSelectionList(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/approver-action-list`, commonDTO);
  }
  redirectToFeedbackForm(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/feedback`, commonDTO);
  }

  // approveWorkflowRequest(workFlowApproveDto: WorkflowApproveDTO): Promise<any> {

  //   return this.http.post(`${this.url}common/approve-workflow-request`, workFlowApproveDto).toPromise();
  // }
  approveWorkflowRequest(workFlowApproveDto: WorkflowApproveDTO) {
    let promise = new Promise((resolve, reject) => {
      this.http
        .post(`${this.url}common/approve-workflow-request`, workFlowApproveDto)
        .toPromise()
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
          //this.customMessage.showErrorMessage(error.msgId, error.error.message);
        });
    });
    return promise;
  }
  getApprovalDetails(commonDto: CommonDTO) {
    return this.http.post(`${this.url}common/approval-details`, commonDto);
  }
  getTransactionDetails(commonDto: CommonDTO) {
    return this.http.post(`${this.url}common/workflow-transaction-details`, commonDto);
  }
  getAuditorTeamSelectionListBySiteIdNUserId(commonDto: CommonDTO) {
    return this.http.post(`${this.url}common/auditor-team`, commonDto);
  }

  getAuditorTeamSelectionSiteWiseListBySiteIdNUserId(commonDto: CommonDTO) {
    return this.http.post(`${this.url}common/auditor-team-sitewise`, commonDto);
  }

  getAuditeeApproverList(approverDTO: ApproverDTO) {
    return this.http.post(`${this.url}common/auditee-team`, approverDTO);
  }

  getApproversListByWorkflowTypeNAuditIdNDeptId(approverDTO: ApproverDTO) {
    return this.http.post(`${this.url}common/approvers-by-wf-type-auditid-deptid`, approverDTO);
  }

  defineApproversByWorkflowTypeNauditIdNDeptID(approverDTO: ApproverDTO) {
    return this.http.post(
      `${this.url}common/define-approver-by-wf-type-auditid-deptid`,
      approverDTO
    );
  }

  submitInWorkflow(approverDTO: ApproverDTO) {
    return this.http.post(`${this.url}common/submit-in-workflow`, approverDTO);
  }
  getSystemDisplayRolesByTeam(approverDTO: ApproverDTO) {
    return this.http.post(`${this.url}common/system-display-roles`, approverDTO);
  }
  getDeptStakeholdersByAuditIdNRoleIdNTeamType(approverDTO: ApproverDTO) {
    return this.http.post(`${this.url}common/audit-program-dept-team-stakeholders`, approverDTO);
  }
  addDeleteStakeHolder(approverDTO: ApproverDTO) {
    return this.http.post(`${this.url}common/manage-stakeholder-crud`, approverDTO);
  }
  getDefineApproversTabList(commonDto: CommonDTO) {
    return this.http.post(`${this.url}common/get-define-approvers-tab-list`, commonDto);
  }
  getClientListByUserId(commonDto: CommonDTO) {
    return this.http.post(`${this.url}common/user-client-list`, commonDto);
  }
  getUmbrellaGroupByClientId(commonDto: CommonDTO) {
    return this.http.post(`${this.url}common/umbrella-group`, commonDto);
  }
  getUserRegistrationRoleListByTeam(commonDto: CommonDTO) {
    return this.http.post(`${this.url}common/team-user-registration-role-list`, commonDto);
  }
  getAuditFirmOnClientSelection(commonDto: CommonDTO) {
    return this.http.post(`${this.url}common/audit-firm-list`, commonDto);
  }

  getDepListByAuditId(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/audit-program-department-list`, commonDTO);
  }

  getAuditProgramNApproverDetailByAuditId(commonDto: CommonDTO) {
    return this.http.post(
      `${this.url}common/audit-program-n-approver-detail-by-audit-id`,
      commonDto
    );
  }

  getPreviewOfEmailByEventIdNClientId(commonDto: CommonDTO) {
    return this.http.post(`${this.url}common/preview-of-email-by-event-id-n-client-id`, commonDto);
  }

  sendMailByEventNClientId(commonDto: CommonDTO) {
    return this.http.post(`${this.url}common/send-email-by-event-id-n-client-id`, commonDto);
  }

  getDepListByTemplateId(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/template-department-list`, commonDTO);
  }

  getFirmListByClientIdNUserId(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/user-client-wise-firm`, commonDTO);
  }

  getAuditProgramNameAfterUpdate(selectedAuditProgramId: string) {
    return this.http.post(`${this.url}common/get-audit-program-name`, selectedAuditProgramId);
  }
  getAuditStageList() {
    return this.http.post(`${this.url}common/get-audit-stage-list`, {});
  }

  getAIRAuditorActionList() {
    return this.http.post(`${this.url}common/air-auditor-action-list`, {});
  }

  getAIRAuditeeActionList() {
    return this.http.post(`${this.url}common/air-auditee-action-list`, {});
  }

  saveAIRItemAuditorAction(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/save-air-item-auditor-action`, commonDTO);
  }

  saveAIRItemAuditeeAction(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/save-air-item-auditee-action`, commonDTO);
  }
  postCommentUserMailComboList(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/post-comment-user-list`, commonDTO);
  }
  addPostComment(postCommentInput: PostCommentInput) {
    return this.http.post(`${this.url}common/post-comment-add`, postCommentInput);
  }
  getPostCommentList(postCommentInput: PostCommentInput) {
    return this.http.post(`${this.url}common/post-comment-list`, postCommentInput);
  }
  getPostCommentCount(postCommentInput: PostCommentInput) {
    return this.http.post(`${this.url}common/post-comment-count`, postCommentInput);
  }
  getButtonRoleMapList(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/button-role-map`, commonDTO);
  }
  getFirmListByClientId(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/client-wise-firm`, commonDTO);
  }
  getAuditProgramDetailByAuditId(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/auditProgramDetail`, commonDTO);
  }
  getBusinessVerticalList(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/business-vertical-list`, commonDTO);
  }

  getReasonListByClientId(commonDto: CommonDTO) {
    return this.http.post(`${this.url}common/reason-list`, commonDto);
  }

  getRatingListByClientId(commonDto: CommonDTO) {
    return this.http.post(`${this.url}common/rating-list`, commonDto);
  }

  getPdcaStatusList(commonDto: CommonDTO) {
    return this.http.post(`${this.url}common/pdca-status-list`, commonDto);
  }
  getAuditStageListForAuditee() {
    return this.http.post(`${this.url}common/get-auditee-stage-list`, {});
  }

  getUserSiteMapNAccess(commonDto: CommonDTO) {
    return this.http.post(`${this.url}common/user-site-map-n-access`, commonDto);
  }

  getUmbrellaGroupByClientIdSiteId(commonDto: CommonDTO) {
    return this.http.post(`${this.url}common/umbrella-group-list-by-clientId-siteId`, commonDto);
  }

  getDefinedWfApproverCount(commonDto: CommonDTO) {
    return this.http.post(`${this.url}common/defined-wf-approver-count`, commonDto);
  }

  isUserHasAuditeeTeamRole(commonDto: CommonDTO) {
    return this.http.post(`${this.url}common/is-user-has-auditee-team-role`, commonDto);
  }

  getSiteSelectionListByCompanyIdNUserIdNAuditFirmId(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/site-list-by-company-id-audit-firm-id`, commonDTO);
  }

  getDropDownText(id, object) {
    const selObj = _.filter(object, function (o) {
      return _.includes(id, o.id);
    });
    return selObj;
  }

  getCodesDetailsByCodeTypeId(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/codes-details-by-code-type-id`, commonDTO);
  }

  getAuditorTeamSelectionListBySiteIdNUserIdNCdAccessType(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/auditor-team-with-cd-access-type`, commonDTO);
  }

  getAuditeeTeamSelectionListBySiteIdNUserIdNCdAccessType(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/auditee-team-with-cd-access-type`, commonDTO);
  }

  getAuditProgramDefinedAuditorAuditeeByRole(commonDTO: CommonDTO) {
    return this.http.post(
      `${this.url}common/audit-program-defined-auditor-auditee-by-role`,
      commonDTO
    );
  }

  getAuditProgramDefinedApproverByWorkflowType(commonDTO: CommonDTO) {
    return this.http.post(
      `${this.url}common/audit-program-defined-approver-by-workflow-type`,
      commonDTO
    );
  }

  getAuditProgramDefinedApproverDepartmentWiseByWorkflowType(commonDTO: CommonDTO) {
    return this.http.post(
      `${this.url}common/audit-program-defined-approver-department-wise-by-workflow-type`,
      commonDTO
    );
  }

  checkUserAccessBySiteIdNUserIdNCdAccessType(commonDTO: CommonDTO) {
    return this.http.post(
      `${this.url}common/check-user-access-by-site-id-n-user-id-n-cdAccessType`,
      commonDTO
    );
  }

  checkInactiveEmailIdsByUserId(userId: number) {
    return this.http.post(`${this.url}checkEmailId/userId`, userId);
  }

  regionComboList(commonDto: CommonDTO) {
    return this.http.post(`${this.url}common/client-region-list`, commonDto);
  }
  regionComboListGlobal(commonDto: CommonDTO) {
    return this.http.post(`${this.url}common/client-region-list-global`, commonDto);
  }

  clientUmbrellaGroupSettingsByGroupIdNSettingId(commonDto: CommonDTO) {
    return this.http.post(
      `${this.url}common/client-umbrella-group-settings-by-groupId-n-settingId`,
      commonDto
    );
  }

  getUserImageByEmail(emailID: string) {
    return this.http.post(`${this.url}common/get/userImage`, emailID);
  }
  getUserAppAccessLog(commonDto: CommonDTO) {
    return this.http.post(`${this.url}common/get/user-app-access-log`, commonDto);
  }

  getUserAvatarImage(commonDto: CommonDTO) {
    return this.http.get(`${this.url}common/get/userImage`);
  }

  getAuditPlanData(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}audit-plan/getAuditPlanDetails`, commonDTO);
  }

  getQuaterList() {
    return this.http.get(`${this.url}codeDetails/quarters`);
  }


  getAppLatestReleaseVersion() {
    return this.http.post(`${this.url}common/get-app-latest-release-version`, {});
  }

  getUserDomain() {
    return this.http.post(`${this.url}common/get-user-domain`, {});
  }

  showReleaseHistoryFlag(commonDto: CommonDTO) {
    return this.http.post(`${this.url}showReleaseHistoryFlag`, commonDto);
  }

  updateReleaseHistoryFlag(commonDto: CommonDTO) {
    return this.http.post(`${this.url}updateReleaseHistoryFlag`, commonDto);
  }

  getAuditeeWFApproverList(commonDto: CommonDTO) {
    return this.http.post(`${this.url}common/get-auditee-approver-list`, commonDto);
  }

  removeBlankSpacesinTinymce(content) {
    content = content
      .replace(/(<p>&nbsp;<\/p>\n){1,}/gi, '<p>&nbsp;</p>')
      .replace(/(&nbsp; ){1,}/gi, '&nbsp;')
      .replace(/(&nbsp;){1,}/gi, '&nbsp;')
      .replace(/(<[\/]?\s*br\s*[\/]?>){1,}/gi, '<br/>')
      .replace(/(<br\/> ){1,}/gi, '<br/>')
      .replace(/(<br\/>){1,}/gi, '<br/>');
    return content;
  }
  //FOR DIV TAG SPACE REMOVAL IN TINY MCE EDITOR
  // removeDivTagBlankSpacesinTinymce(content) {
  //   content = content.replace(/(<div>&nbsp;<\/div>\n){1,}/gi, "<div>&nbsp;</div>").replace(/(&nbsp; ){1,}/gi, "&nbsp;").replace(/(&nbsp;){1,}/gi, "&nbsp;")
  //     .replace(/(<[\/]?\s*br\s*[\/]?>){1,}/gi, "<br/>")
  //     .replace(/(<br\/> ){1,}/gi, "<br/>")
  //     .replace(/(<br\/>){1,}/gi, "<br/>");
  //   return content;
  // }

  logout(token: string) {
    return this.http.post(`${this.url}logout`, token);
  }

  exportPowerPoint(commonDTO: CommonDTO) {
    let authKey;
    authKey = localStorage.getItem(this.token);
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        Authorization: authKey,
      }),
    };

    return this.http.post(`${this.url}common/exportPowerPointTemplate`, commonDTO, httpOptions);
  }

  //To Get Return Log list
  getReturnLogList(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/audit-return-log`, commonDTO);
  }

  getAuditeeStageList() {
    return this.http.post(`${this.url}common/get-auditee-stage-list`, {});
  }
  // getHandoverApproverList(workflowHandoverDTO: WorkflowHandoverDTO) {
  //   return this.http.post(`${this.url}common/auditee-team`, workflowHandoverDTO);
  // }

  getHandoverSelectionList(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/handoverteam`, commonDTO);
  }

  getAuditAreaList(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/auditArea`, commonDTO);
  }

  getAuditAreaListbyAuditFirm(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/auditAreaByFirmId`, commonDTO);
  }
  getAuditAreaListAuditFirm(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/auditAreaByAuditFirm`, commonDTO);
  }

  getAuditAreaListbySite(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/auditAreaBySiteId`, commonDTO);
  }
  getAuditScoreBoardList(data) {
    return this.http.post(`${this.url}scoreBoard/auditScore`, data);
  }

  getBusinessVertical(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/businessVertical`, commonDTO);
  }

  getAuditScoreTableList(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}scoreBoard/auditScoreTableDetails`, commonDTO);
  }

  downloadExcel(auditScoreBoardDTO: AuditScoreBoardDTO) {
    let authKey;
    authKey = localStorage.getItem(this.token);
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        Authorization: authKey,
      }),
    };
    return this.http.post(`${this.url}scoreBoard/downloadExcel`, auditScoreBoardDTO, httpOptions);
  }

  getAuditAreaComboListByRegionNCompanyNSiteId(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/auditArea-by-regionNCompanyNSiteId`, commonDTO);
  }

  getAuditAreaComboListByUserId(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/auditArea-by-userId`, commonDTO);
  }

  getAllAvailableAuditAreaComboList(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/all-available-auditArea`, commonDTO);
  }

  getSiteAndAuditAreaIdByAuditId(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/get-siteId-by-auditId`, commonDTO);
  }

  getModifiedDate() {
    return this.http.get(`${this.url}umbrellaSettings/checkDeployedFileTime`);
  }

  updateDefaultHomeScreen(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/update-default-home-screen`, commonDTO);
  }

  updateAuitPlan(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}audit-plan/update`, commonDTO);
  }

  updateAuitPlanSelectAll(dtoList: any[]) {
    return this.http.post(`${this.url}audit-plan/updateSelectedAll`, dtoList);
  }

  copyPlanningValidations(auditPlanDTO: AuditPlanDTO) {
    return this.http.post(`${this.url}audit-plan/copyPlanningValidations`, auditPlanDTO);
  }

  copyPlanning(auditPlanDTO: AuditPlanDTO) {
    return this.http.post(`${this.url}audit-plan/copyPlanning`, auditPlanDTO);
  }

  getHistoryDetails(auditPlanDTO: AuditPlanDTO) {
    return this.http.post(`${this.url}audit-plan/history`, auditPlanDTO);
  }

  getHeaderList(commonDTO: CommonDTO) {
    return this.http.post(`${this.url}common/get-header-list-observation`, commonDTO);
  }
}
